<!--
/**
* @name: List.vue
* @description: 业务员管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input placeholder="请输入业务员姓名" clearable v-model="para.name"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input placeholder="请输入手机号码" clearable v-model="para.phone"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择业务员类型" clearable v-model="para.type">
          <k-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAdd">新建</y-button>
      </y-query-item>
    </y-query>
    <y-query :hasSearchButton="false">
      <y-query-item>
        <k-auto-complete ref="au" :data="companyList" v-model="para.companyCode" key-field="code" value-field="name" search-field="name" layer-width="" placeholder="请选择推广公司">
          <div slot-scope="{ row }" :key="row.code" class="list">
            <span class="name">{{ row.name }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择状态" clearable v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <div style="width: 240px;"></div>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="salemanList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <div class="popup_box">
      <k-popup bind="v-if" okText="保存" :title="isEdit ? '修改业务员信息' : '新建业务员信息'" :show.sync="isShowPopup" @after-ok="onSave">
        <div style="width: 650px;">
          <y-form titleAlign="left" titleWidth="100px" contentWidth="400px">
            <y-form-item title="业务员ID:">
              <k-input placeholder="按照编码规则自动生成" block disabled v-model="editPara.id"></k-input>
            </y-form-item>
            <y-form-item title="推广公司:">
              <k-select placeholder="请选择推广公司" block clearable v-model="editPara.companyCode">
                <k-option v-for="item in companyList" :selected="editPara.companyCode == item.code" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
              </k-select>
            </y-form-item>
            <y-form-item title="业务员类型:" required>
              <k-select placeholder="请选择业务员类型" :clearable="isEdit ? false : true" block :disabled="isEdit ? true : false" v-model="editPara.type">
                <k-option v-for="item in typeList" :selected="editPara.type == item.value" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
              </k-select>
            </y-form-item>
            <y-form-item title="业务员姓名:" required>
              <k-input placeholder="请输入业务员姓名" block clearable v-model="editPara.name"></k-input>
            </y-form-item>
            <y-form-item title="手机号码:" required>
              <k-input placeholder="请输入手机号码" clearable v-model="editPara.phone" v-validate="'regex(/^[1][3,4,5,6,7,8,9][0-9]{9}$/)'" block maxlength="11"></k-input>
            </y-form-item>
            <y-form-item title="邀请码:">
              <k-input placeholder="按照编码规则自动生成" block disabled v-model="editPara.inviteCode"></k-input>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_ADD,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_UPDATE,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALESMAN_COMPANY_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
} from "@/assets/modules/apiList";
import insensitive from '@/components/Insensitive.vue';
const initPara = () => ({
  name: "",
  phone: "",
  type: "",
  companyCode: "",
  status: "",
  pageCurrent: 1,
  pageSize: 15,
});
const initEditPara = () => ({
  id: "",
  companyCode: "",
  type: "",
  name: "",
  phone: "",
  inviteCode: "",
});
export default {
  data() {
    return {
      isLoading: false,
      isSaving: false,
      salemanList: [],
      companyList: [],
      statusList: [
        { value: 1, label: "在职" },
        { value: 2, label: "离职" },
      ],
      typeList: [],
      para: initPara(),
      editPara: initEditPara(),
      isEdit: false,
      total: 0,
      isShowPopup: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "业务员ID",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "推广公司名称",
          field: "",
          style: {
            width: 200,
            textAlign: "center",
            "white-space": "normal",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.companyList.length; i++) {
              if (row.companyCode == this.companyList[i].code) {
                temp = this.companyList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "关联门店数",
          field: "shopCount",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "业务员类型",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.typeList.length; i++) {
              if (row.type == this.typeList[i].value) {
                temp = this.typeList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "业务员姓名",
          field: "name",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender:row=>(
            <div>
              <insensitive val={row.name} type="name" isShowEye={false}></insensitive>
            </div>
          )
        },
        {
          name: "手机号码",
          field: "phone",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            return <insensitive val={row.phone} type="phone" isShowEye={false}></insensitive>
          },
        },
        {
          name: "邀请码",
          field: "inviteCode",
          style: {
            width: 160,
            textAlign: "center",
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: { textAlign: "center", width: 130 },
        },
        {
          name: "状态",
          field: "status_str",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            return (
              <div>
                <span class={row.status == "1" ? this.css.enabled : this.css.disabled}></span>
                <span>{row.status == "1" ? "在职" : "离职"}</span>
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "action",
          style: { textAlign: "center" },
          customRender: (row) => {
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            const demissionButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.demission(row);
                }}
              >
                离职
              </a>
            );
            if (row.status == "1") {
              return (
                <div>
                  {editButton}&#12288;{demissionButton}
                </div>
              );
            } else {
              return <div>{editButton}</div>;
            }
          },
        },
      ];
    },
    onEdit(row) {
      this.isEdit = true;
      this.editPara = JSON.parse(JSON.stringify(row));
      this.isShowPopup = true;
    },
    onAdd() {
      this.isEdit = false;
      this.editPara = initEditPara();
      this.isShowPopup = true;
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getSalemanList();
    },
    onReset() {
      this.para = initPara();
      this.$refs.au.inputText = "";
      this.getSalemanList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getSalemanList();
    },
    getCompanyList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALESMAN_COMPANY_LIST,
        para: {},
      }).then((res) => {
        this.companyList = res;
      });
    },
    getTypeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "salesmanType",
        },
      }).then((res) => {
        this.typeList = res;
      });
    },
    getSalemanList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_PAGELIST,
        para,
      }).then((res) => {
        this.salemanList = res.pageList || [];
        this.total = res.total;
      });
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      // 内容检查
      if (!para.type) {
        return tip("请选择业务员类型");
      }
      if (!para.name) {
        return tip("请输入业务员姓名");
      }
      if (para.type == "sales01" && !para.companyCode) {
        return tip("推广公司不能为空");
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(para.phone)) {
        return tip("请输入正确的手机号码");
      }
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_UPDATE : NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SALEMZN_ADD,
        para: {
          id: this.editPara.id,
          code: this.editPara.code,
          companyCode: this.editPara.companyCode,
          type: this.editPara.type,
          name: this.editPara.name,
          phone: this.editPara.phone,
          status: this.isEdit ? this.editPara.status : "",
        },
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.getSalemanList();
          this.isEdit = false;
          this.editPara = initEditPara();
          this.isShowPopup = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    demission(row) {
      this.$controller.open({
        name: "demission",
        query: {
          refresh: new Date() - 0,
          code: row.code,
        },
      });
    },
  },
  created() {
    this.getCompanyList();
    this.getSalemanList();
    this.getTypeList();
  },
};
</script>

<style lang="postcss" module="css">
.enabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #52c41a;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.disabled {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
</style>
